<section class="container">
  <div class="header-wrapper">
    @if (showReleaseContent) {
      <div>
        <p class="headerText">Release v{{ requestedReleaseNumber }}</p>
      </div>
    }
    @if (!showReleaseContent) {
      <div>
        <p class="headerText">Latest Releases</p>
      </div>
    }
  </div>
  <div class="content-wrapper">
    @if (loading) {
      <div class="loading">
        <aw-spinner></aw-spinner>
      </div>
    }

    @if (!loading && !hasReleases) {
      <div data-qa-id="releases-text-no-releases">
        There are no releases for this tenant.
      </div>
    }

    @if (!loading && !showReleaseContent) {
      <div>
        @if (hasReleases) {
          <table class="mdl-data-table" data-qa-id="releases-table">
            <thead>
              <tr>
                <th>Release #</th>
                <th>Release Date</th>
                <th>Release Notes</th>
                <th>Status</th>
                <th>Released</th>
              </tr>
            </thead>
            <tbody>
              @for (release of releases; track release) {
                <tr>
                  <td><a [routerLink]="['../releases', release.ReleaseNumber]">{{ release.ReleaseNumber }}</a></td>
                  <td>{{ release.ReleaseDate | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
                  <td>{{ release.ReleaseNotes }}</td>
                  <td>
                    @if (!release.Released) {
                      <div>
                        @if (!release.Loading && !release.hasError) {
                          <div>
                            @if (!release.IsPublishAllowed) {
                              <mat-icon color="mat-warn" title="Not Synced - Reset">cloud_off</mat-icon>
                            }
                            @if (release.IsPublishAllowed) {
                              <mat-icon color="mat-accent" title="Synchronised With Live">cloud_done</mat-icon>
                            }
                          </div>
                        }
                        @if (!release.Loading && release.hasError) {
                          <div>
                            <mat-icon class="mat-warn">error</mat-icon>
                          </div>
                        }
                        @if (release.Loading) {
                          <div>
                            <aw-spinner></aw-spinner>
                          </div>
                        }
                      </div>
                    }
                  </td>
                  @if (!release.Released) {
                    <td>
                      <button mat-button
                        [disabled]="!release.IsPublishAllowed || isPublishLoading"
                        class="mat-accent mat-raised-button publish-button"
                        (click)="release.IsPublishAllowed && publish(release.ReleaseNumber)"
                        id="publish-release">
                        @if (!isPublishLoading) {
                          <span>Publish</span>
                        }
                        @if (isPublishLoading) {
                          <mat-spinner diameter="20"></mat-spinner>
                        }
                      </button>
                    </td>
                  }
                  @if (release.Released) {
                    <td>Released</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    }

    @if (!loading && showReleaseContent && release) {
      <div>
        <div>
          <p><span class="subheaderText">Created On : </span><span class="contentText">{{ release.ReleaseDate }}</span></p>
          <p><span class="subheaderText">Release Notes : </span><span class="contentText">{{ release.ReleaseNotes }}</span></p>
        </div>
        <table class="mdl-data-table">
          <thead>
            <tr>
              <th>Package</th>
              <th>Version</th>
              <th>Created By</th>
              <th>Created On</th>
            </tr>
          </thead>
          <tbody>
            @for (package of release.Packages; track package) {
              <tr>
                <td>{{ package.PackageName | translate: 'Text' | async}}</td>
                <td>{{ package.Version }}{{ package.MinorVersion > 0 ? '.' + package.MinorVersion : '' }}</td>
                <td>{{ package.CreatedBy }}</td>
                <td>{{ package.CreatedOn | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</section>
